export type FilesTabComponentTranslation = {
  table: {
    head: {
      actions: string;
      createdAt: string;
      createdBy: string;
      name: string;
      resourceType: string;
      size: string;
    };
  };
  title: string;
};

export const filesTabComponentTranslation: FilesTabComponentTranslation = {
  table: {
    head: {
      actions: 'Akcje',
      createdAt: 'Data dodania',
      createdBy: 'Dodane przez',
      name: 'Nazwa',
      resourceType: 'Typ',
      size: 'Rozmiar',
    },
  },
  title: 'Pliki',
};
